const routes = [
  {
    path: '/error/notFound',
    name: 'notFound',
    component: () => import('@/views/index/error/notFound.vue'),
    meta: {}
  },
  {
    path: '*',
    redirect: '/error/notFound'
  },
  /*{
    path: '/',
    name: 'app',
    redirect: '/himacs-solid-surface/himacs-finder'
  },*/
  {
    path: '/all-colors',
    name: 'ViewAll',
    component: () => import('@/views/products/viewAll.vue'),
    meta: {
      metaCode: 'PCD_ALL',
      metaCodePrefixCountry: true,
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/all-colors/filter/:filterNm1/:filterCd1',
    name: 'ViewAll filter',
    component: () => import('@/views/products/viewAll.vue'),
    meta: {
      metaCode: 'PCD_ALL',
      metaCodePrefixCountry: true,
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/all-colors/filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
    name: 'ViewAll filter',
    component: () => import('@/views/products/viewAll.vue'),
    meta: {
      metaCode: 'PCD_ALL',
      metaCodePrefixCountry: true,
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/all-colors/filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
    name: 'ViewAll filter',
    component: () => import('@/views/products/viewAll.vue'),
    meta: {
      metaCode: 'PCD_ALL',
      metaCodePrefixCountry: true,
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/all-sample',
    name: 'ViewAllSample',
    component: () => import('@/views/products/viewAllSample.vue'),
    meta: {
      metaCode: 'PCD_SAMPLE',
      metaCodePrefixCountry: true,
      pageType: 'PF',
      gl: false,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: false,
      cn: false
    }
  },
  {
    path: '/hflor',
    name: 'app',
    component: () => import('@/views/pub/products/layoutPcd.vue'),
    children: [
      {
        path: 'about',
        name: 'component_pcd_about',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_HFLOR',
          enhPageType: 'hflor',
          searchCode: 'PRD_FLOORING',
          metaCode: 'PCD_HFLOR',
          colorSectionCode: 'PRD_FLOORING',
          metaCodePrefixCountry: true,
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PCD',
          gl: true,
          us: true
        }
      },
      {
        path: 'specialty',
        name: 'component_pcd_specialty',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_SPT',
          enhPageType: 'hflor',
          searchCode: 'PRD_FLOORING',
          metaCode: 'PCD_SPT',
          colorSectionCode: 'FLOOR_SPT',
          metaCodePrefixCountry: true,
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'SPT',
          mainTitle: 'Specialty',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'lvt',
        name: 'component_pcd_lvt',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_LVT',
          enhPageType: 'hflor',
          searchCode: 'PRD_FLOORING',
          metaCode: 'PCD_LVT',
          colorSectionCode: 'FLOOR_LUX',
          metaCodePrefixCountry: true,
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'LVT',
          mainTitle: 'Luxury Vinyl Tile',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'looselay',
        name: 'component_pcd_looselay',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_LOS',
          enhPageType: 'hflor',
          searchCode: 'PRD_FLOORING',
          metaCode: 'PCD_LOS',
          colorSectionCode: 'FLOOR_LOS',
          metaCodePrefixCountry: true,
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'LOS',
          mainTitle: 'Looselay',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'spc',
        name: 'component_pcd_spc',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_SPC',
          enhPageType: 'hflor',
          searchCode: 'PRD_FLOORING',
          metaCode: 'PCD_SPC',
          colorSectionCode: 'FLOOR_SPC',
          metaCodePrefixCountry: true,
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'SPC',
          mainTitle: 'SPC Rigid Core',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'homogeneous',
        name: 'component_pcd_homogeneous',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_HOMO',
          enhPageType: 'hflor',
          searchCode: 'PRD_FLOORING',
          metaCode: 'PCD_HOMO',
          colorSectionCode: 'FLOOR_HOM',
          metaCodePrefixCountry: true,
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HOMO',
          mainTitle: 'Homogeneous',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'heterogeneous',
        name: 'component_pcd_heterogeneous',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_HET',
          enhPageType: 'hflor',
          searchCode: 'PRD_FLOORING',
          metaCode: 'PCD_HET',
          colorSectionCode: 'FLOOR_HET',
          metaCodePrefixCountry: true,
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HET',
          mainTitle: 'Heterogeneous',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
    ]
  },


  {
    path: '/',
    name: 'app',
    component: () => import('@/views/pub/products/layoutPcd.vue'),
    children: [
      {
        path: 'viatera-quartz-surface',
        name: 'component_pcd_viatera',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_VIATERA',
          enhPageType: 'viatera',
          searchCode: 'VIATERA_COLOR',
          metaCode: 'PCD_VIATERA',
          colorSectionCode: 'VIATERA_COLOR',
          metaCodePrefixCountry: true,
          code: 'VIATERA_COLOR',
          type: 'VIATERA',
          mainTitle: 'VIATERA',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'himacs-solid-surface',
        name: 'component_pcd_himacs',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_HIMACS',
          enhPageType: 'himacs',
          searchCode: 'HIMACS_COLOR',
          metaCode: 'PCD_HIMACS',
          colorSectionCode: 'HIMACS_COLOR',
          metaCodePrefixCountry: true,
          code: 'HIMACS_COLOR',
          type: 'HIMACS',
          mainTitle: 'HIMACS',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'teracanto-porcelain-surface',
        name: 'component_pcd_teracanto',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_TERACANTO',
          enhPageType: 'teracanto',
          searchCode: 'TERACANTO_COLOR',
          metaCode: 'PCD_TERACANTO',
          colorSectionCode: 'TERACANTO_COLOR',
          metaCodePrefixCountry: true,
          code: 'TERACANTO_COLOR',
          type: 'TERACANTO',
          mainTitle: 'TERACANTO',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'borte-panel',
        name: 'component_pcd_borte',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_BORTE',
          enhPageType: 'borte',
          searchCode: 'BORTE_COLOR',
          metaCode: 'PCD_BORTE',
          colorSectionCode: 'BORTE_COLOR',
          metaCodePrefixCountry: true,
          code: 'BORTE_COLOR',
          type: 'BORTE',
          mainTitle: 'BORTE',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: false,
          cf: false,
          jp: false,
          ru: false,
          cn: false
        }
      },
      {
        path: '/benif-architectural-film',
        name: 'ENH Benif Category Detail',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_BENIF',
          enhPageType: 'benif',
          searchCode: 'BENIF_COLOR',
          metaCode: 'PCD_BENIF',
          colorSectionCode: 'BENIF_COLOR',
          metaCodePrefixCountry: true,
          code: 'BENIF_COLOR',
          type: 'BENIF',
          mainTitle: 'BENIF',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: '/deco-film',
        name: 'ENH Deco Category Detail',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_DECO',
          enhPageType: 'deco',
          searchCode: 'DECO_COLOR',
          metaCode: 'PCD_DECO',
          colorSectionCode: 'DECO_COLOR',
          metaCodePrefixCountry: true,
          code: 'DECO_COLOR',
          type: 'DECO',
          mainTitle: 'Deco Film',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/exterior-film',
        name: 'ENH Exterior Category Detail',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_EXTERIOR',
          enhPageType: 'exterior',
          searchCode: 'EXTERIOR_COLOR',
          metaCode: 'PCD_EXTERIOR',
          colorSectionCode: 'EXTERIOR_COLOR',
          metaCodePrefixCountry: true,
          code: 'EXTERIOR_COLOR',
          type: 'EXTERIOR',
          mainTitle: 'Exterior Film',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
    ]
  },


  {
    path: '/vizuon-sign-graphic',
    name: 'vizuon-app',
    component: () => import('@/views/pub/products/layoutPcd.vue'),
    children: [
      {
        path: 'about',
        name: 'about vizuon',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_VIZUON_A',
          enhPageType: 'vizuon',
          searchCode: 'PCD_VIZUON_A',
          metaCode: 'PCD_VIZUON_A',
          colorSectionCode: 'VIZUON_COLOR',
          metaCodePrefixCountry: true,
          code: 'PCD_VIZUON_A',
          parentType: 'VIZUON',
          type: 'VIZUON_A',
          mainTitle: 'VIZUON',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },


      {
        path: 'vehicle',
        name: 'about vehicle',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_VEH',
          enhPageType: 'vizuon',
          searchCode: 'PCD_VEH',
          metaCode: 'PCD_VEH',
          colorSectionCode: 'VIZUON_VT',
          metaCodePrefixCountry: true,
          code: 'PCD_VEH',
          parentType: 'VIZUON',
          type: 'VEH',
          mainTitle: 'Vehicles and Transportation',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'signs-and-displays',
        name: 'about signs-and-displays',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_SD',
          enhPageType: 'vizuon',
          searchCode: 'PCD_SD',
          metaCode: 'PCD_SD',
          colorSectionCode: 'VIZUON_SD',
          metaCodePrefixCountry: true,
          code: 'PCD_SD',
          parentType: 'VIZUON',
          type: 'SD',
          mainTitle: 'Signs and Displays',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'illuminated-sign',
        name: 'about illuminated-sign',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_ILLUM',
          enhPageType: 'vizuon',
          searchCode: 'PCD_ILLUM',
          metaCode: 'PCD_ILLUM',
          colorSectionCode: 'VIZUON_IS',
          metaCodePrefixCountry: true,
          code: 'PCD_ILLUM',
          parentType: 'VIZUON',
          type: 'ILLUM',
          mainTitle: 'Illuminated Sign',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'architecture',
        name: 'about architecture',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_ARCH',
          enhPageType: 'vizuon',
          searchCode: 'PCD_ARCH',
          metaCode: 'PCD_ARCH',
          colorSectionCode: 'VIZUON_AR',
          metaCodePrefixCountry: true,
          code: 'PCD_ARCH',
          parentType: 'VIZUON',
          type: 'ARCH',
          mainTitle: 'Architecture',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'eco-solutions',
        name: 'about eco-solutions',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_ECO',
          enhPageType: 'vizuon',
          searchCode: 'PCD_ECO',
          metaCode: 'PCD_ECO',
          colorSectionCode: 'VIZUON_ES',
          metaCodePrefixCountry: true,
          code: 'PCD_ECO',
          parentType: 'VIZUON',
          type: 'ECO',
          mainTitle: 'Eco Solutions',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'corporate-branding',
        name: 'about corporate-branding',
        component: () => import('@/views/pub/products/componentPCD.vue'),
        meta: {
          enhCode: 'PCD_CORP',
          enhPageType: 'vizuon',
          searchCode: 'PCD_CORP',
          metaCode: 'PCD_CORP',
          colorSectionCode: 'VIZUON_CB',
          metaCodePrefixCountry: true,
          code: 'PCD_CORP',
          parentType: 'VIZUON',
          type: 'CORP',
          mainTitle: 'Corporate Branding',
          pageType: 'PCD',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },


    ]
  },


/*  {
    path: '/viatera',
    redirect: '/viatera-quartz-surface'
  },*/
  {
    path: '/viatera/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'VIATERA_COLOR',
      enhPageType: 'viatera',
      code: 'VIATERA_COLOR',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },
  {
    path: '/viatera/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'VIATERA_COLOR',
      enhPageType: 'viatera',
      code: 'VIATERA_COLOR',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },
  /*{
    path: '/himacs',
    name: 'Himacs Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'HIMACS_COLOR',
      code: 'HIMACS_COLOR',
      type: 'HIMACS',
      mainTitle: 'HIMACS',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      // {
      //   path: '',
      //   component: () => import('@/views/products/CommonCategoryDetail.vue'),
      //   meta: {
      //     metaCode: 'HIMACS_COLOR',
      //     code: 'HIMACS_COLOR',
      //     pageType: 'PCD',
      //     gl: true,
      //     us: true,
      //     ca: true,
      //     cf: true,
      //     jp: true,
      //     ru: true,
      //     cn: true
      //   }
      // },
      {
        path: 'about/:about',
        component: () => import('@/views/products/CommonCategoryDetail.vue'),
        meta: {
          metaCode: 'HIMACS_COLOR',
          code: 'HIMACS_COLOR',
          pageType: 'PCD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      }
    ]
  },
  {
    path: '/hflor/lvt',
    name: 'Luxury Vinyl Tile Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_LVT',
      metaCodePrefixCountry: true,
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'LVT',
      mainTitle: 'Luxury Vinyl Tile',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/looselay',
    name: 'Looselay Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_LOS',
      metaCodePrefixCountry: true,
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'LOS',
      mainTitle: 'Looselay',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/spc',
    name: 'SPC Rigid Core Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_SPC',
      metaCodePrefixCountry: true,
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'SPC',
      mainTitle: 'SPC Rigid Core',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/homogeneous',
    name: 'Homogeneous Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_HOMO',
      metaCodePrefixCountry: true,
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'HOMO',
      mainTitle: 'Homogeneous',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/heterogeneous',
    name: 'Heterogeneous Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_HET',
      metaCodePrefixCountry: true,
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'HET',
      mainTitle: 'Heterogeneous',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/specialty',
    name: 'Specialty Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_SPT',
      metaCodePrefixCountry: true,
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'SPT',
      mainTitle: 'Specialty',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/hflor/:category_name/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'PRD_FLOORING',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: '/hflor/lvt-flooring/:prd_name/:contentId',
        name: 'Luxury Vinyl Tile Category Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'FLOOR_LUX',
          enhPageType: 'hflor',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'LVT',
          mainTitle: 'Luxury Vinyl Tile',
          pageType: 'PD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/looselay/:prd_name/:contentId',
        name: 'Looselay Category Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'FLOOR_LOS',
          enhPageType: 'hflor',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'LOS',
          mainTitle: 'Looselay',
          pageType: 'PD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/spc-click/:prd_name/:contentId',
        name: 'SPC Rigid Core Category Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'FLOOR_SPC',
          enhPageType: 'hflor',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'SPC',
          mainTitle: 'SPC Rigid Core',
          pageType: 'PD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/homogeneous-sheet/:prd_name/:contentId',
        name: 'Homogeneous Category Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'FLOOR_HOM',
          enhPageType: 'hflor',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HOMO',
          mainTitle: 'Homogeneous',
          pageType: 'PD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/heterogeneous-sheet/:prd_name/:contentId',
        name: 'Heterogeneous Category Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'FLOOR_HET',
          enhPageType: 'hflor',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HET',
          mainTitle: 'Heterogeneous',
          pageType: 'PD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/specialty/:prd_name/:contentId',
        name: 'Heterogeneous Category Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'FLOOR_SPT',
          enhPageType: 'hflor',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'SPT',
          mainTitle: 'Specialty',
          pageType: 'PD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/sports-flooring/:prd_name/:contentId',
        name: 'Heterogeneous Category Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          enhPageType: 'hflor',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'SPT',
          mainTitle: 'Specialty',
          pageType: 'PD',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      }
    ]
  },
  {
    path: '/hflor/lvt-flooring/detail/:slug',
    name: 'Luxury Vinyl Time Category Detail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'FLOOR_LUX',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'LVT',
      mainTitle: 'Luxury Vinyl Time',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/looselay/detail/:slug',
    name: 'Looselay Category Detail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'FLOOR_LOS',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'LOS',
      mainTitle: 'Looselay',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/spc-click/detail/:slug',
    name: 'SPC Rigid Core Category Detail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'FLOOR_SPC',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'SPC',
      mainTitle: 'SPC Rigid Core',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/homogeneous/detail/:slug',
    name: 'Homogeneous Category Detail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'FLOOR_HOM',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'HOMO',
      mainTitle: 'Homogeneous',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/heterogeneous/detail/:slug',
    name: 'Heterogeneous Category Detail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'FLOOR_HET',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'HET',
      mainTitle: 'Heterogeneous',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/specialty/detail/:slug',
    name: 'Heterogeneous Category Detail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'FLOOR_SPT',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'SPT',
      mainTitle: 'Specialty',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/sports-flooring/detail/:slug',
    name: 'Sports Flooring Category Detail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'PRD_FLOORING',
      enhPageType: 'hflor',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'SPC',
      mainTitle: 'Sports Flooring',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  // SEO 적용 router
  /*{
    path: '/hflor/:main_collection_name',
    name: 'hflor category detail (seo)',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_HFLOR',
      code: 'PRD_FLOORING',
      type: 'HFLOR',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/hflor/hflor-finder/all-colors/filter/:filterNm/:filterCd',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'PRD_FLOORING',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'HFLOR',
      mainTitle: 'HFLOR',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true

    }
  },
  {
    path: '/hflor/hflor-finder/all-colors/filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
    name: 'filter (collection and hue)',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'PRD_FLOORING', code: 'PRD_FLOORING', parentType: 'HFLOR', type: 'HFLOR_LVT', mainTitle: 'HFLOR', pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/hflor-finder/all-colors/filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
    name: 'filter (multi pattern)',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'PRD_FLOORING', code: 'PRD_FLOORING', parentType: 'HFLOR', type: 'HFLOR_LVT', mainTitle: 'HFLOR', pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },
  {
    path: '/hflor/hflor-finder/all-sample',
    name: 'hflor sample',
    component: () => import('@/views/products/CommonSampleProductFinder.vue'),
    meta: {
      metaCode: 'PRD_FLOORING',
      code: 'PRD_FLOORING',
      parentType: 'HFLOR',
      type: 'HFLOR',
      mainTitle: 'HFLOR',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true

    }
  },
  {
    path: '/hflor/hflor-finder/:main_collection_name',
    name: 'hflor finder (seo)',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'PRD_FLOORING',
      code: 'PRD_FLOORING',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: '/hflor/hflor-finder/all-colors',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          rememberedCategory: null,
          metaCode: 'PRD_FLOORING',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/hflor-finder/lvt-flooring',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'FLOOR_LUX',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/hflor-finder/homogeneous-sheet',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'FLOOR_HOM',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/hflor-finder/heterogeneous-sheet',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'FLOOR_HET',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/hflor-finder/specialty',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'FLOOR_SPT',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/hflor-finder/spc-click',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'FLOOR_SPC',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/hflor-finder/looselay',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'FLOOR_LOS',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: ':hflorFilterCd/filter/:filterNm/:filterCd',
        name: 'hflor-finder1',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterVal',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterVal1/:filterNm2', // (in the case inNew or colors is filterNm2)
        name: 'new finder + other filterr',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR_LVT',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterVal1/:filterNm2/:filterVal2',
        name: 'filter (collection and product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          code: 'PCD_HFLOR',
          parentType: 'HFLOR',
          type: 'HFLOR_LVT',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterVal1/:filterNm2/:filterVal2/:filterNm3/:filterVal3',
        name: 'filter (collection and product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR_LVT',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/hflor/hflor-finder/all-colors/:rootCollection/filter/collection/:leafCollection',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'PRD_FLOORING',
          code: 'PRD_FLOORING',
          parentType: 'HFLOR',
          type: 'HFLOR',
          mainTitle: 'HFLOR',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      }
    ]
  },
  /*{
    path: '/viatera-quartz-surface',
    name: 'Viatera Category Detail (seo)',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_VIATERA',
      metaCodePrefixCountry: true,
      code: 'VIATERA_COLOR',
      type: 'VIATERA',
      mainTitle: 'VIATERA',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/viatera-quartz-surface/viatera-finder',
    name: 'Viatera finder (seo)',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'VIATERA_COLOR',
      code: 'VIATERA_COLOR',
      parentType: 'VIATERA',
      type: 'VIATERA',
      mainTitle: 'VIATERA',
      categoryId: '502',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    },
    children: [
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIATERA_COLOR',
          code: 'VIATERA_COLOR',
          parentType: 'VIATERA',
          type: 'VIATERA',
          mainTitle: 'VIATERA',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIATERA_COLOR',
          code: 'VIATERA_COLOR',
          parentType: 'VIATERA',
          type: 'VIATERA',
          mainTitle: 'VIATERA',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2',
        name: 'new finder + other filter',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIATERA_COLOR',
          code: 'VIATERA_COLOR',
          parentType: 'VIATERA',
          type: 'VIATERA',
          mainTitle: 'VIATERA',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIATERA_COLOR',
          code: 'VIATERA_COLOR',
          parentType: 'VIATERA',
          type: 'VIATERA',
          mainTitle: 'VIATERA',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIATERA_COLOR',
          code: 'VIATERA_COLOR',
          parentType: 'VIATERA',
          type: 'VIATERA',
          mainTitle: 'VIATERA',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
    ]
  },
  {
    path: '/viatera-quartz-surface/sample',
    name: 'viatera sample',
    component: () => import('@/views/products/CommonSampleProductFinder.vue'),
    meta: {
      metaCode: 'VIATERA_COLOR',
      code: 'VIATERA_COLOR',
      parentType: 'VIATERA',
      type: 'VIATERA',
      mainTitle: 'VIATERA',
      categoryId: '502',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    },
  },
  {
    path: '/viatera-quartz-surface/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'VIATERA_COLOR',
      enhPageType: 'viatera',
      code: 'VIATERA_COLOR',
      parentType: 'VIATERA',
      type: 'VIATERA',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },
  {
    path: '/viatera-quartz-surface/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'VIATERA_COLOR', enhPageType: 'viatera', code: 'VIATERA_COLOR', pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },
  /*{
    path: '/himacs-solid-surface',
    name: 'himacs Category Detail (seo)',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_HIMACS',
      metaCodePrefixCountry: true,
      code: 'HIMACS_COLOR',
      type: 'HIMACS',
      mainTitle: 'HIMACS',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/himacs-solid-surface/himacs-finder',
    name: 'himacs finder (seo)',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'HIMACS_COLOR',
      code: 'HIMACS_COLOR',
      parentType: 'HIMACS',
      categoryId: '484',
      type: 'HIMACS',
      mainTitle: 'HIMACS',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'HIMACS_COLOR', code: 'HIMACS_COLOR', parentType: 'HIMACS', type: 'HIMACS', mainTitle: 'HIMACS', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'HIMACS_COLOR', code: 'HIMACS_COLOR', parentType: 'HIMACS', type: 'HIMACS', mainTitle: 'HIMACS', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterNm2/:filterCd2',
        name: 'new finder + other filter',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'HIMACS_COLOR', code: 'HIMACS_COLOR', parentType: 'HIMACS', type: 'HIMACS', mainTitle: 'HIMACS', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'HIMACS_COLOR', code: 'HIMACS_COLOR', parentType: 'HIMACS', type: 'HIMACS', mainTitle: 'HIMACS', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'HIMACS_COLOR', code: 'HIMACS_COLOR', parentType: 'HIMACS', type: 'HIMACS', mainTitle: 'HIMACS', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
    ]
  },
  {
    path: '/himacs-solid-surface/sample',
    name: 'himacs sample',
    component: () => import('@/views/products/CommonSampleProductFinder.vue'),
    meta: {
      metaCode: 'HIMACS_COLOR',
      code: 'HIMACS_COLOR',
      parentType: 'HIMACS',
      categoryId: '484',
      type: 'HIMACS',
      mainTitle: 'HIMACS',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/himacs-solid-surface/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'HIMACS_COLOR',
      enhPageType: 'himacs',
      code: 'HIMACS_COLOR',
      parentType: 'HIMACS',
      type: 'HIMACS',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/himacs-solid-surface/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'HIMACS_COLOR', enhPageType: 'himacs', code: 'HIMACS_COLOR', pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
 /* {
    path: '/teracanto-porcelain-surface',
    name: 'Teracanto Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_TERACANTO',
      metaCodePrefixCountry: true,
      code: 'TERACANTO_COLOR',
      type: 'TERACANTO',
      mainTitle: 'TERACANTO',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/teracanto-porcelain-surface/teracanto-finder',
    name: 'Teracanto finder',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'TERACANTO_COLOR',
      code: 'TERACANTO_COLOR',
      parentType: 'TERACANTO',
      type: 'TERACANTO',
      mainTitle: 'TERACANTO',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'TERACANTO_COLOR',
          code: 'TERACANTO_COLOR',
          parentType: 'TERACANTO',
          type: 'TERACANTO',
          mainTitle: 'TERACANTO',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'TERACANTO_COLOR',
          code: 'TERACANTO_COLOR',
          parentType: 'TERACANTO',
          type: 'TERACANTO',
          mainTitle: 'TERACANTO',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2',
        name: 'new finder + other filter',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'TERACANTO_COLOR',
          code: 'TERACANTO_COLOR',
          parentType: 'TERACANTO',
          type: 'TERACANTO',
          mainTitle: 'TERACANTO',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'TERACANTO_COLOR',
          code: 'TERACANTO_COLOR',
          parentType: 'TERACANTO',
          type: 'TERACANTO',
          mainTitle: 'TERACANTO',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'TERACANTO_COLOR',
          code: 'TERACANTO_COLOR',
          parentType: 'TERACANTO',
          type: 'TERACANTO',
          mainTitle: 'TERACANTO',
          pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
    ]
  },
  {
    path: '/teracanto-porcelain-surface/sample',
    name: 'teracanto sample',
    component: () => import('@/views/products/CommonSampleProductFinder.vue'),
    meta: {
      metaCode: 'TERACANTO_COLOR',
      code: 'TERACANTO_COLOR',
      parentType: 'TERACANTO',
      type: 'TERACANTO',
      mainTitle: 'TERACANTO',
      pageType: 'PF',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/teracanto-porcelain-surface/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'TERACANTO_COLOR',
      enhPageType: 'teracanto',
      code: 'TERACANTO_COLOR',
      parentType: 'TERACANTO',
      type: 'TERACANTO',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/teracanto-porcelain-surface/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'TERACANTO_COLOR', enhPageType: 'teracanto', code: 'TERACANTO_COLOR', pageType: 'PD',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: true,
      ru: true,
      cn: true
    }
  },
  /*{
    path: '/borte-panel',
    name: 'BORTE Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_BORTE',
      metaCodePrefixCountry: true,
      code: 'BORTE_COLOR',
      type: 'BORTE',
      mainTitle: 'BORTE',
      pageType: 'PCD',
      gl: true,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: false,
      cn: false
    }
  },*/
  {
    path: '/borte-panel/borte-finder',
    name: 'BORTE finder',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'BORTE_COLOR', code: 'BORTE_COLOR', parentType: 'BORTE', type: 'BORTE', mainTitle: 'BORTE', pageType: 'PF',
      gl: true,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: false,
      cn: false
    },
    children: [
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BORTE_COLOR', code: 'BORTE_COLOR', parentType: 'BORTE', type: 'BORTE', mainTitle: 'BORTE', pageType: 'PF',
          gl: true,
          us: true,
          ca: false,
          cf: false,
          jp: false,
          ru: false,
          cn: false
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BORTE_COLOR', code: 'BORTE_COLOR', parentType: 'BORTE', type: 'BORTE', mainTitle: 'BORTE', pageType: 'PF',
          gl: true,
          us: true,
          ca: false,
          cf: false,
          jp: false,
          ru: false,
          cn: false
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2',
        name: 'new finder + other filter',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BORTE_COLOR', code: 'BORTE_COLOR', parentType: 'BORTE', type: 'BORTE', mainTitle: 'BORTE', pageType: 'PF',
          gl: true,
          us: true,
          ca: false,
          cf: false,
          jp: false,
          ru: false,
          cn: false
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BORTE_COLOR', code: 'BORTE_COLOR', parentType: 'BORTE', type: 'BORTE', mainTitle: 'BORTE', pageType: 'PF',
          gl: true,
          us: true,
          ca: false,
          cf: false,
          jp: false,
          ru: false,
          cn: false
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BORTE_COLOR', code: 'BORTE_COLOR', parentType: 'BORTE', type: 'BORTE', mainTitle: 'BORTE', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
    ]
  },
  {
    path: '/borte-premium-panel/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/borte-panel/:prd_name/:contentId'}
    },
    meta: {
      metaCode: 'BORTE_COLOR',
      enhPageType: 'rest',
      code: 'BORTE_COLOR',
      parentType: 'BORTE',
      type: 'BORTE',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: false,
      cn: false
    }
  },
  {
    path: '/borte-panel/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'BORTE_COLOR',
      enhPageType: 'rest',
      code: 'BORTE_COLOR',
      parentType: 'BORTE',
      type: 'BORTE',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: false,
      cn: false
    }
  },
  {
    path: '/borte-panel/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'BORTE_COLOR',
      enhPageType: 'rest',
      code: 'BORTE_COLOR',
      parentType: 'BORTE',
      type: 'BORTE',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: false,
      cn: false
    }
  },
  {
    path: '/borte-premium-panel/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/borte-panel/detail/:slug'}
    },
    meta: {
      metaCode: 'BORTE_COLOR',
      enhPageType: 'rest',
      code: 'BORTE_COLOR',
      parentType: 'BORTE',
      type: 'BORTE',
      pageType: 'PD',
      gl: true,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: false,
      cn: false
    }
  },
  /*{
    path: '/benif-architectural-film',
    name: 'Benif Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_BENIF',
      metaCodePrefixCountry: true,
      code: 'BENIF_COLOR',
      type: 'BENIF',
      mainTitle: 'BENIF',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: false,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/benif-architectural-film/benif-finder',
    name: 'Benif finder',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'BENIF_COLOR', code: 'BENIF_COLOR', parentType: 'BENIF', type: 'BENIF', mainTitle: 'BENIF', pageType: 'PF',
      gl: true,
      us: true,
      ca: false,
      cf: false,
      jp: false,
      ru: true,
      cn: true
    },
    children: [
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BENIF_COLOR', code: 'BENIF_COLOR', parentType: 'BENIF', type: 'BENIF', mainTitle: 'BENIF', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BENIF_COLOR', code: 'BENIF_COLOR', parentType: 'BENIF', type: 'BENIF', mainTitle: 'BENIF', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2',
        name: 'new finder + other filter',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BENIF_COLOR', code: 'BENIF_COLOR', parentType: 'BENIF', type: 'BENIF', mainTitle: 'BENIF', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BENIF_COLOR', code: 'BENIF_COLOR', parentType: 'BENIF', type: 'BENIF', mainTitle: 'BENIF', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'BENIF_COLOR', code: 'BENIF_COLOR', parentType: 'BENIF', type: 'BENIF', mainTitle: 'BENIF', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
    ]
  },
  {
    path: '/benif-architectural-film/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'BENIF_COLOR',
      enhPageType: 'rest',
      code: 'BENIF_COLOR',
      parentType: 'BENIF',
      type: 'BENIF',
      pageType: 'PD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: false,
      ru: true,
      cn: true
    }
  },
  {
    path: '/benif-interior-film/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/benif-architectural-film/:prd_name/:contentId'}
    },
    meta: {
      metaCode: 'BENIF_COLOR',
      enhPageType: 'rest',
      code: 'BENIF_COLOR',
      parentType: 'BENIF',
      type: 'BENIF',
      pageType: 'PD'
    }
  },
  {
    path: '/benif-architectural-film/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'BENIF_COLOR', enhPageType: 'rest', code: 'BENIF_COLOR',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: false,
      ru: true,
      cn: true
    }
  },
  {
    path: '/benif-interior-film/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/benif-architectural-film/detail/:slug'}
    },
    meta: {metaCode: 'BENIF_COLOR', enhPageType: 'rest', code: 'BENIF_COLOR'}
  },
  /*{
    path: '/deco-film',
    name: 'Deco Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_DECO',
      metaCodePrefixCountry: true,
      code: 'DECO_COLOR',
      type: 'DECO',
      mainTitle: 'Deco Film',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/deco-film/deco-finder',
    name: 'Deco finder',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'DECO_COLOR',
      code: 'DECO_COLOR',
      parentType: 'DECOFILM',
      type: 'DECOFILM',
      mainTitle: 'Deco Film',
      pageType: 'PF',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'DECO_COLOR',
          code: 'DECO_COLOR',
          parentType: 'DECOFILM',
          type: 'DECOFILM',
          mainTitle: 'Deco Film',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'DECO_COLOR',
          code: 'DECO_COLOR',
          parentType: 'DECOFILM',
          type: 'DECOFILM',
          mainTitle: 'Deco Film',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2',
        name: 'new finder + other filter',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'DECO_COLOR',
          code: 'DECO_COLOR',
          parentType: 'DECOFILM',
          type: 'DECOFILM',
          mainTitle: 'Deco Film',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'DECO_COLOR',
          code: 'DECO_COLOR',
          parentType: 'DECOFILM',
          type: 'DECOFILM',
          mainTitle: 'Deco Film',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'DECO_COLOR', code: 'DECO_COLOR', parentType: 'DECOFILM', type: 'DECOFILM', mainTitle: 'Deco Film', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
    ]
  },
  {
    path: '/deco-film/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'DECO_COLOR', enhPageType: 'deco', code: 'DECO_COLOR', parentType: 'DECOFILM', type: 'DECO', pageType: 'PD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  /*{
    path: '/deco-foil/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/deco-film/:prd_name/:contentId'}
    },
    meta: {metaCode: 'DECO_COLOR', enhPageType: 'deco', code: 'DECO_COLOR', parentType: 'DECOFILM', type: 'DECO', pageType: 'PD'}
  },*/
  {
    path: '/deco-film/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'DECO_COLOR', enhPageType: 'deco', code: 'DECO_COLOR', pageType: 'PD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  /*{
    path: '/deco-foil/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/deco-film/detail/:slug'}
    },
    meta: {metaCode: 'DECO_COLOR', enhPageType: 'deco', code: 'DECO_COLOR'}
  },*/
  /*{
    path: '/vizuon-sign-graphic',
    name: 'vizuon category detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_VIZUON_A',
      metaCodePrefixCountry: true,
      code: 'PCD_VIZUON_A',
      parentType: 'VIZUON',
      type: 'VIZUON_A',
      mainTitle: 'VIZUON',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/vizuon-sign-graphic/vehicle',
    name: 'Vehicles and Transportation Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_VEH',
      metaCodePrefixCountry: true,
      code: 'PCD_VEH',
      parentType: 'VIZUON',
      type: 'VEH',
      mainTitle: 'Vehicles and Transportation',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/vizuon-sign-graphic/signs-and-displays',
    name: 'Signs and Displays Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_SD',
      metaCodePrefixCountry: true,
      code: 'PCD_SD',
      parentType: 'VIZUON',
      type: 'SD',
      mainTitle: 'Signs and Displays',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/vizuon-sign-graphic/illuminated-sign',
    name: 'Illuminated Sign Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_ILLUM',
      metaCodePrefixCountry: true,
      code: 'PCD_ILLUM',
      parentType: 'VIZUON',
      type: 'ILLUM',
      mainTitle: 'Illuminated Sign',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/vizuon-sign-graphic/architecture',
    name: 'Architecture Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_ARCH',
      metaCodePrefixCountry: true,
      code: 'PCD_ARCH',
      parentType: 'VIZUON',
      type: 'ARCH',
      mainTitle: 'Architecture',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/vizuon-sign-graphic/eco-solutions',
    name: 'Eco Solutions Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_ECO',
      metaCodePrefixCountry: true,
      code: 'PCD_ECO',
      parentType: 'VIZUON',
      type: 'ECO',
      mainTitle: 'Eco Solutions',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/vizuon-sign-graphic/corporate-branding',
    name: 'Corporate Branding Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_CORP',
      metaCodePrefixCountry: true,
      code: 'PCD_CORP',
      parentType: 'VIZUON',
      type: 'CORP',
      mainTitle: 'Corporate Branding',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/vizuon-sign-graphic/:main_collection_name',
    name: 'vizuon category detail (seo)',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_VIZUON',
      metaCodePrefixCountry: true,
      code: 'PCD_VIZUON',
      parentType: 'VIZUON',
      type: 'VIZUON_A',
      mainTitle: 'VIZUON',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/vizuon-sign-graphic/vizuon-finder/:main_collection_name',
    name: 'vizuon finder (seo)',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'VIZUON_COLOR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: '/vizuon-sign-graphic/vizuon-finder/vehicles-and-transportation',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_VT', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/vizuon-finder/signs-and-displays',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_SD', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/vizuon-finder/illuminated-sign',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_IS', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/vizuon-finder/architecture',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_AR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/vizuon-finder/eco-solutions',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_ES', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/vizuon-finder/corporate-branding',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_CB', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR', code: 'VIZUON_COLOR', parentType: 'VIZUON_A', type: 'VIZUON_A', mainTitle: 'VIZUON', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterVal',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterVal1/:filterNm2', // (in the case inNew or colors is filterNm2)
        name: 'new finder + other filterr',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterVal1/:filterNm2/:filterVal2',
        name: 'filter (collection and product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR', code: 'PCD_VIZUON', parentType: 'VIZUON_A', type: 'VIZUON_A', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/vizuon-finder/:rootCollection/filter/collection/:leafCollection',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'VIZUON_COLOR',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON_A',
          type: 'VIZUON_A',
          mainTitle: 'VIZUON',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      }
    ]
  },
  {
    path: '/vizuon-sign-graphic/:category_name/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'VIZUON_COLOR',
      code: 'PCD_VIZUON',
      pageType: 'PD',
      enhPageType: 'vizuon',
      searchType: 'VIZUON_A',
    },
    children: [
      {
        path: '/vizuon-sign-graphic/vehicles-and-transportation/:prd_name/:contentId',
        name: 'Vehicles and Transportation Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_VT',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON_A',
          enhPageType: 'vizuon',
          type: 'VEH',
          mainTitle: 'Vehicles and Transportation',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/signs-and-displays/:prd_name/:contentId',
        name: 'Signs and Displays Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_SD',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON_A',
          enhPageType: 'vizuon',
          type: 'SD',
          mainTitle: 'Signs and Displays',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/illuminated-sign/:prd_name/:contentId',
        name: 'Illuminated Sign Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_IS',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON_A',
          type: 'ILLUM',
          mainTitle: 'Illuminated Sign',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/architecture/:prd_name/:contentId',
        name: 'Architecture Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_AR',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON_A',
          type: 'ARCH',
          mainTitle: 'Architecture',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/eco-solutions/:prd_name/:contentId',
        name: 'Eco Solutions Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_ES',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON_A',
          type: 'ECO',
          mainTitle: 'Eco Solutions',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/corporate-branding/:prd_name/:contentId',
        name: 'Eco Solutions Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_CB',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON_A',
          type: 'CORP',
          mainTitle: 'Eco Solutions',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      }
    ]
  },
  {
    path: '/vizuon-sign-graphic/:category_name/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'VIZUON_COLOR',
      enhPageType: 'vizuon',
      code: 'PCD_VIZUON',
      pageType: 'PD',
      searchType: 'VIZUON_A',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: '/vizuon-sign-graphic/vehicles-and-transportation/detail/:slug',
        name: 'Vehicles and Transportation Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_VT',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON',
          type: 'VEH',
          mainTitle: 'Vehicles and Transportation',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/signs-and-displays/detail/:slug',
        name: 'Signs and Displays Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_SD',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON',
          type: 'SD',
          mainTitle: 'Signs and Displays',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/illuminated-sign/detail/:slug',
        name: 'Illuminated Sign Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_IS',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON',
          type: 'ILLUM',
          mainTitle: 'Illuminated Sign',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/architecture/detail/:slug',
        name: 'Architecture Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_AR',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON',
          type: 'ARCH',
          mainTitle: 'Architecture',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: '/vizuon-sign-graphic/eco-solutions/detail/:slug',
        name: 'Eco Solutions Product Detail',
        component: () => import('@/views/products/CommonProductDetail.vue'),
        meta: {
          metaCode: 'VIZUON_ES',
          enhPageType: 'vizuon',
          code: 'PCD_VIZUON',
          parentType: 'VIZUON',
          type: 'CORP',
          mainTitle: 'Eco Solutions',
          pageType: 'PD',
          searchType: 'VIZUON_A',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      }
    ]
  },
  /*{
    path: '/exterior-film',
    name: 'Exterior Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'PCD_EXTERIOR',
      metaCodePrefixCountry: true,
      code: 'EXTERIOR_COLOR',
      type: 'EXTERIOR',
      mainTitle: 'Exterior Film',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/exterior-film/exterior-finder',
    name: 'Exterior finder',
    component: () => import('@/views/products/CommonProductFinder.vue'),
    meta: {
      metaCode: 'EXTERIOR_COLOR',
      code: 'EXTERIOR_COLOR',
      parentType: 'EXTERIORFILM',
      type: 'EXTERIORFILM',
      mainTitle: 'Exterior Film',
      pageType: 'PF',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    },
    children: [
      {
        path: 'filter/:filterNm',
        name: 'new finder',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'EXTERIOR_COLOR',
          code: 'EXTERIOR_COLOR',
          parentType: 'EXTERIORFILM',
          type: 'EXTERIORFILM',
          mainTitle: 'Exterior Film',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm/:filterCd',
        name: 'filter (collection or product type)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'EXTERIOR_COLOR',
          code: 'EXTERIOR_COLOR',
          parentType: 'EXTERIORFILM',
          type: 'EXTERIORFILM',
          mainTitle: 'Exterior Film',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2',
        name: 'new finder + other filter',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'EXTERIOR_COLOR',
          code: 'EXTERIOR_COLOR',
          parentType: 'EXTERIORFILM',
          type: 'EXTERIORFILM',
          mainTitle: 'Exterior Film',
          pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2',
        name: 'filter (collection and hue)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'EXTERIOR_COLOR', code: 'EXTERIOR_COLOR', parentType: 'EXTERIORFILM', pageType: 'PF',
          gl: true,
          us: false,
          ca: false,
          cf: false,
          jp: true,
          ru: true,
          cn: true
        }
      },
      {
        path: 'filter/:filterNm1/:filterCd1/:filterNm2/:filterCd2/:filterNm3/:filterCd3',
        name: 'filter (multi pattern)',
        component: () => import('@/views/products/CommonProductFinder.vue'),
        meta: {
          metaCode: 'EXTERIOR_COLOR', code: 'EXTERIOR_COLOR', parentType: 'EXTERIORFILM', pageType: 'PF',
          gl: true,
          us: true,
          ca: true,
          cf: true,
          jp: false,
          ru: true,
          cn: true
        }
      },
    ]
  },
  {
    path: '/exterior-film/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'EXTERIOR_COLOR', code: 'EXTERIOR_COLOR', enhPageType: 'exterior', parentType: 'EXTERIORFILM', type: 'EXTERIOR', pageType: 'PD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  /*{
    path: '/exterior-foil/:prd_name/:contentId',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/exterior-film/:prd_name/:contentId'}
    },
    meta: {
      metaCode: 'EXTERIOR_COLOR',
      enhPageType: 'exterior',
      code: 'EXTERIOR_COLOR',
      parentType: 'EXTERIORFILM',
      type: 'EXTERIOR',
      pageType: 'PD'
    }
  },*/
  {
    path: '/exterior-film/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    meta: {
      metaCode: 'EXTERIOR_COLOR', enhPageType: 'exterior', code: 'EXTERIOR_COLOR', pageType: 'PD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  /*{
    path: '/exterior-foil/detail/:slug',
    name: 'CommonProductDetail',
    component: () => import('@/views/products/CommonProductDetail.vue'),
    redirect: to => {
      return {path: '/exterior-film/detail/:slug'}
    },
    meta: {metaCode: 'EXTERIOR_COLOR', enhPageType: 'exterior', code: 'EXTERIOR_COLOR'}
  },*/
  /*{
    path: '/exterior-film',
    name: 'Home Appliance Surface Film Category Detail',
    component: () => import('@/views/products/CommonCategoryDetail.vue'),
    meta: {
      metaCode: 'EXTERIOR_COLOR',
      code: 'EXTERIOR_COLOR',
      type: 'HASF',
      mainTitle: 'Home Appliance Surface Film',
      pageType: 'PCD',
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/automotive/automotive-skin',
    name: 'AutomotiveSkin',
    component: () => import('@/views/products/automotive/AutomotiveSkin/index.vue'),
    meta: {
      metaCode: 'PCD_AS',
      metaCodePrefixCountry: true,
      pageType: 'PCD',
      mainTitle: 'Vegan Leather',
      code: 'AUTOMOTIVE',
      location: [
        'Products',
        'Automotive',
        'Vegan Leather'
      ],
      gl: true,
      us: true
    }
  },
  {
    path: '/automotive/lightweight-component',
    name: 'LightweightComponent',
    component: () => import('@/views/products/automotive/LightweightComponent/index.vue'),
    meta: {
      metaCode: 'PCD_LC',
      metaCodePrefixCountry: true,
      pageType: 'PCD',
      code: 'AUTOMOTIVE',
      location: [
        'Products',
        'Automotive',
        'Lightweight Component'
      ],
      gl: true,
      us: true
    }
  },
  {
    path: '/automotive/automotive-component',
    name: 'AutomotiveComponent',
    component: () => import('@/views/products/automotive/AutomotiveComponent/index.vue'),
    meta: {
      metaCode: 'PCD_AC',
      metaCodePrefixCountry: true,
      pageType: 'PCD',
      code: 'AUTOMOTIVE',
      location: [
        'Products',
        'Automotive',
        'Automotive Component'
      ],
      gl: true,
      us: true
    }
  },
  {
    path: '/industrial-film/home-appliance-surface-film',
    name: 'HomeApplianceSurfaceFilm',
    component: () => import('@/views/products/industrialFilm/VinylCoatedMaterial/index.vue'),
    meta: {
      metaCode: 'PCD_HASF',
      code: 'PCD_HASF',
      pageType: 'PCD',
      metaCodePrefixCountry: true,
      location: [
        'Products',
        'Home Appliance Surface Film',
        'About Home Appliance Surface Film'
      ],
      gl: true,
      us: false,
      ca: false,
      cf: false,
      jp: true,
      ru: true,
      cn: true
    }
  },
  {
    path: '/himacs-solid-surface/sink',
    name: 'himacs Other (seo)',
    component: () => import('@/views/products/HimacsOtherProducts.vue'),
    meta: {
      metaCode: 'HIMACS_OTHER', code: 'HIMACS_OTHER',
      gl: false,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: false,
      cn: false
    }
  },
  // US VIATERA sink 운영 종료 2026.01.20
  /*{
    path: '/viatera-quartz-surface/sink',
    name: 'Viatera Other (seo)',
    component: () => import('@/views/products/ViateraOtherProducts.vue'),
    meta: {
      metaCode: 'VIATERA_OTHER', code: 'VIATERA_OTHER',
      gl: true,
      us: true,
      ca: true,
      cf: true,
      jp: false,
      ru: true,
      cn: true
    }
  },*/
  {
    path: '/viatera-quartz-surface/sink',
    redirect: '/viatera-quartz-surface/viatera-finder',
  }

]

export default routes
